import React, { useState, useEffect, useRef } from "react";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import AllRoute from "../Layout/AllRoute/AllRoute";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { ThemeContext } from "../Themecontext/Themecontext";
import { FilterProject } from "../Redux/Slice/login/loginSlice";
import { useLocation } from "react-router-dom";

const Layout = () => {

    const dispatch = useDispatch();

    const { Colourdata } = useSelector((state) => state.ClientLogin);

    const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
    const iscolourDark = Colourdata?.data?.find(
        (el) => el.ExeName === "GRAYDARKNEW"
    );

    const [theme, setTheme] = useState(
        Cookies.get("theme") || "light"
    );

    useEffect(() => {
        document.body.setAttribute("data-theme", theme);
        Cookies.set("theme", theme, { expires: 7 });
    }, [theme]);

    // Listen for theme changes from other components (e.g., VoiceAssistant)
    useEffect(() => {
        const handleThemeChange = (e) => {
            if (e.detail) {
                setTheme(e.detail);
            }
        };
        window.addEventListener('themeChange', handleThemeChange);
        return () => window.removeEventListener('themeChange', handleThemeChange);
    }, []);

    const isdark = theme;

    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 992;

            setIsMobile(mobile);

            if (mobile) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const location = useLocation();
    const scrollAreaRef = useRef(null);

    useEffect(() => {
        if (scrollAreaRef.current) {
            scrollAreaRef.current.scrollTop = 0;
        }
    }, [location.pathname]);

    useEffect(() => {
        dispatch(FilterProject());
    }, [dispatch]);

    const exeNameMap = {
        GREY: { light: "GRAYNEW", dark: "GRAYDARKNEW" },
        FAS: { light: "NEWFAS", dark: "NEWFASDARK" },
        PAYROLL: { light: "NEWPAYROLL", dark: "NEWPAYROLLDARK" },
        MILLSTAGE: { light: "NEWMILLSTAGE", dark: "NEWMILLSTAGEDARK" },
        MAINTENANCE: { light: "MAINTENANCESTORE", dark: "MAINTENANCESTOREDARK" },
        STORE: { light: "MAINTENANCESTORE", dark: "MAINTENANCESTOREDARK" },
        COLOUR: { light: "GRAYNEW", dark: "GRAYDARKNEW" },
        "ORDER APPROVAL": { light: "GRAYNEW", dark: "GRAYDARKNEW" },
        "COLLECTION MAN": { light: "GRAYNEW", dark: "GRAYDARKNEW" }
    };
    const getModuleFromPath = () => {
        const path = location.pathname.toLowerCase();

        const fasPaths = [
            "fas", "trialbalance", "ledger", "balancesheet", "profitandloss", "fundandflow",
            "receivable", "payable", "customer", "supplier", "bank", "saledashboard",
            "monthwisepartywisesale", "partywiseitemwisesale", "productiongroupwise",
            "itemwisemonthwise", "itemwisesummary", "partyitemwisesummary", "monthitemparty",
            "partywisequarter", "purchasedashboard", "monthwisepartywisepurchase",
            "partywiseitemwisepurchase", "monthwisebookwise", "bookwise", "bookwisesubbookwise",
            "bookwisemonthlyanylysis", "gstr", "tds"
        ];
        if (fasPaths.some(p => path.includes(p))) return "FAS";

        const payrollPaths = [
            "payroll", "salaryanalysisdashboard", "salarystatement", "depwisesalarysummary",
            "employeeprofile", "salarysummary", "ptstatement", "esistatement", "pfstatement",
            "esi_pf_pt_summary", "departmentwisepresent"
        ];
        if (payrollPaths.some(p => path.includes(p))) return "PAYROLL";

        const maintenancePaths = [
            "maintenance", "inwardanalysism", "inwarditemwise", "issueitemwise",
            "itemwisemachinewiseconsumption", "machinegroupwiseconsumtion",
            "machinewiseconsumption", "machinegroupmonthwiseconsumption",
            "itemwisedailyandmonthly", "fsnanalysis", "stockanalysis", "abcanalysis",
            "partyitemanalysismain", "itemsupplieranaylysismain"
        ];
        if (maintenancePaths.some(p => path.includes(p))) return "MAINTENANCE";

        const colourPaths = [
            "colour", "inwardanalysis", "machinegroupwisecosting", "masterwisemachinegroupcosting",
            "machinegroupwithmachinecosting", "machinegroupcostingsummary",
            "masterwisemonthlyconsumption", "machinegroupcostanlysis", "machinegroupbatchcosting",
            "masterwiseconsumption", "masterwisecosting", "/abc", "/fsn", "/stock", "monthlystock",
            "itemsupplieranaylysis", "partyitemanalysis"
        ];
        if (colourPaths.some(p => path.includes(p))) return "COLOUR";

        const millPaths = [
            "millstage", "greystagebalance", "stagewiseinoutbalance", "lootwisereport",
            "groupwisestagewisebalance", "groupwisestagedetailreport", "groupwisepartywisedetailreport",
            "machinewisebatchdetail"
        ];
        if (millPaths.some(p => path.includes(p))) return "MILLSTAGE";

        if (path.includes("orderapproval") || path.includes("approval")) return "ORDER APPROVAL";
        if (path.includes("collectionman") || path.includes("aging")) return "COLLECTION MAN";

        return "GREY";
    };

    const activeModuleName = getModuleFromPath();
    const exeNames = exeNameMap[activeModuleName] || exeNameMap.GREY;

    const moduleColorLight = Colourdata?.data?.find(el => el.ExeName === exeNames.light);
    const moduleColorDark = Colourdata?.data?.find(el => el.ExeName === exeNames.dark);

    const finalColors = (isdark === "light" ? moduleColorLight : moduleColorDark) || (isdark === "light" ? iscolour : iscolourDark);

    const thumbColor = isdark === "light" ? finalColors?.Colour12 : (finalColors?.Colour8 || finalColors?.Colour10);

    const getPageBg = () => {
        if (isdark === "light") {
            switch (activeModuleName) {
                case "GREY": return finalColors?.Colour7 || "#f1f5f9";
                case "FAS": return "#f7efdd";
                case "PAYROLL": return finalColors?.Colour1 || "#f4f7fa";
                case "MAINTENANCE":
                case "STORE": return finalColors?.Colour1 || "#f4f7fa";
                case "COLOUR": return finalColors?.Colour1 || "#f4f7fa";
                case "ORDER APPROVAL": return finalColors?.Colour1 || "#f4f7fa";
                case "COLLECTION MAN": return finalColors?.Colour1 || "#f4f7fa";
                default: return finalColors?.Colour7 || "#f1f5f9";
            }
        } else {
            switch (activeModuleName) {
                case "GREY": return finalColors?.Colour10 || "#020617";
                case "FAS": return finalColors?.Colour3 || "#020617";
                case "PAYROLL": return finalColors?.Colour2 || "#020617";
                case "MAINTENANCE":
                case "STORE": return finalColors?.Colour1 || "#020617";
                case "COLOUR": return finalColors?.Colour4 || "#020617";
                case "ORDER APPROVAL": return finalColors?.Colour10 || "#020617";
                case "COLLECTION MAN": return finalColors?.Colour10 || "#020617";
                default: return finalColors?.Colour10 || finalColors?.Colour7 || "#020617";
            }
        }
    };

    const trackColor = getPageBg();
    const loaderBg = getPageBg();

    useEffect(() => {
        if (thumbColor) {
            document.documentElement.style.setProperty("--theme-scrollbar-thumb", thumbColor);
            // Derive a hover color using color-mix (adding 20% white/black depending on theme)
            document.documentElement.style.setProperty("--theme-scrollbar-thumb-hover", `color-mix(in srgb, ${thumbColor}, ${isdark === 'light' ? 'black 15%' : 'white 15%'})`);
        }
        if (trackColor) document.documentElement.style.setProperty("--theme-scrollbar-track", trackColor);
        if (loaderBg) document.documentElement.style.setProperty("--theme-loader-bg", loaderBg);
    }, [thumbColor, trackColor, loaderBg, isdark]);


    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    height: "100vh",
                    overflow: "hidden",
                    "--theme-loader-bg": loaderBg,
                    "--theme-scrollbar-track": trackColor,
                    "--theme-scrollbar-thumb": thumbColor || (isdark === 'light' ? '#cbd5e1' : '#334155'),
                    "--theme-scrollbar-thumb-hover": thumbColor ? `color-mix(in srgb, ${thumbColor}, ${isdark === 'light' ? 'black 15%' : 'white 15%'})` : undefined
                }}
            >

                {/* Sidebar */}

                <div
                    style={{
                        width: sidebarOpen ? "300px" : "0px",
                        transition: "width 0.3s",
                        background: isdark === "light" ? "#F1F5F9" : "#020617",
                        height: "100%",
                        position: isMobile ? "fixed" : "relative",
                        zIndex: 1000,
                        overflow: "hidden",
                        boxShadow: sidebarOpen ? "0 0 10px rgba(0,0,0,0.2)" : "none"
                    }}
                >
                    <Sidebar />
                </div>


                {/* Overlay mobile */}

                {sidebarOpen && isMobile && (
                    <div
                        onClick={toggleSidebar}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0,0,0,0.3)",
                            zIndex: 900
                        }}
                    />
                )}


                {/* Main Content */}

                <div
                    style={{
                        flex: 1,
                        minWidth: 0,
                        display: "flex",
                        flexDirection: "column",
                        height: "100vh",
                        overflow: "hidden"
                    }}
                >

                    {/* Header */}

                    <div
                        style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 100,
                            background: "#fff"
                        }}
                    >
                        <Header toggleSidebar={toggleSidebar} />
                    </div>


                    {/* Scroll Area */}

                    <div
                        ref={scrollAreaRef}
                        className="theme-scroll"
                        style={{
                            flex: 1,
                            minWidth: 0,
                            overflowY: "auto",
                            backgroundColor: loaderBg || (isdark === "light" ? "#ffffff" : "#020617"),
                        }}
                    >

                        <AllRoute />

                        {/* 
                  `  <div style={{ marginTop: "20px" }}>
                        <GreyTable
                            columns={columns}
                            data={tableData}
                        />
                    </div>

                    <div style={{ marginTop: "30px" }}>
                        <Chart data={chartData} />
                    </div>` */}


                    </div>

                </div>

            </div>
        </ThemeContext.Provider>
    );
};

export default Layout;